import { useGlobal } from '../context/GlobalContext';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import { formatProductData } from '../helper/formatProductData';
import { ProductGridSkeleton } from './SkeletonLoader';

const ProductListOne = (props) => {
    const { addToCart, cartItems, wishlistItems, addToWishlist, removeFromWishlist } = useGlobal();
    const [productsData, setProductsData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                const response = await api.get('/api/products');
                const formatted = response.data.map(formatProductData).filter(p => p.isHotDeal);
                setProductsData(formatted);
            } catch (err) {
                console.error("Failed to fetch product list", err);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);
    return (
        <div className="product" style={{ marginTop: 'clamp(2.5rem, 6vw, 4.5rem)' }}>
            <div className="container container-lg"  >
                <div className="section-heading" style={{ marginBottom: 'clamp(1.5rem, 3vw, 2.5rem)' }}>
                    <h3 className="mb-0 fw-bold text-heading text-start wow fadeInLeft" data-wow-duration="0.7s">Shop Your Cart</h3>
                </div>
                <style>{`
                    @media (min-width: 992px) {
                        .col-custom-5 { width: 20%; flex: 0 0 auto; }
                    }
                    .pl-wishlist-btn {
                        position: absolute;
                        top: 10px;
                        left: 10px;
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 5;
                        transition: all 0.2s ease;
                        cursor: pointer;
                    }
                    .pl-wishlist-btn:hover {
                        transform: scale(1.1);
                    }
                    .product-card__cart {
                        white-space: nowrap;
                        z-index: 4;
                    }
                    @media (max-width: 576px) {
                        .pl-wishlist-btn {
                            top: 6px;
                            left: 6px;
                            width: 26px;
                            height: 26px;
                        }
                        .pl-wishlist-btn i {
                            font-size: 13px;
                        }
                        .product-card__cart {
                            font-size: 11px !important;
                            padding: 3px 8px !important;
                            margin-top: 6px !important;
                            margin-right: 6px !important;
                            gap: 4px !important;
                        }
                        .product-card__cart i {
                            font-size: 12px !important;
                        }
                    }
                    @media (max-width: 380px) {
                        .product-card__cart {
                            font-size: 10px !important;
                            padding: 2px 6px !important;
                            margin-top: 4px !important;
                            margin-right: 4px !important;
                            gap: 3px !important;
                        }
                    }
                `}</style>
                <div className="row gy-4 g-12">
                    {loading ? (
                        <ProductGridSkeleton count={5} columnsClass="col-custom-5 col-md-3 col-sm-4 col-6" />
                    ) : productsData.slice(0, 10).map((product, index) => {
                        const isInCart = cartItems?.some(item => String(item.id) === String(product.id));
                        const isWishlisted = wishlistItems?.some(item => String(item.id) === String(product.id));
                        return (
                        <div key={product.id} className="col-custom-5 col-md-3 col-sm-4 col-6" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
                            <div className="product-card hover-lift p-12 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 d-flex flex-column" style={{ height: '100%', width: '100%' }}>
                                {/* Wishlist Button */}
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (isWishlisted) {
                                            removeFromWishlist(product.id);
                                        } else {
                                            addToWishlist(product);
                                        }
                                    }}
                                    className={`pl-wishlist-btn border ${
                                        isWishlisted
                                            ? 'bg-danger-50 border-danger-200 text-danger-600'
                                            : 'bg-white border-gray-100 text-gray-400 hover-text-main-600 hover-border-main-600 shadow-xs'
                                    }`}
                                    title={isWishlisted ? "In Wishlist (Click to remove)" : "Add to Wishlist"}
                                    aria-label="Wishlist"
                                >
                                    <i className={`${isWishlisted ? 'ph-fill ph-heart text-danger-600' : 'ph ph-heart'} text-sm`} />
                                </button>

                                        {/* 1. Photo */}
                                        <Link
                                            to={`/product-details/${product.slug || product.id}`}
                                            className="product-card__thumb flex-center"
                                            style={{ height: '130px', width: '100%', padding: '4px' }}
                                        >
                                            <img
                                                src={product.image}
                                                alt={product.name}
                                                style={{ width: 'auto', height: '100%', maxWidth: '100%', maxHeight: '120px', objectFit: 'contain' }}
                                            />
                                        </Link>

                                        {/* 2. Middle: Add to Cart / View Cart Button */}
                                        <div className="product-card__action my-8 w-100">
                                            {isInCart ? (
                                                <Link
                                                    to="/cart"
                                                    className="product-card__cart btn bg-main-600 text-white hover-bg-main-700 py-8 px-14 text-xs rounded-pill flex-center gap-6 w-100"
                                                >
                                                    View Cart <i className="ph ph-shopping-cart" />
                                                </Link>
                                            ) : (
                                                <button
                                                    type="button"
                                                    onClick={(e) => { e.preventDefault(); addToCart(product, 1, product.defaultVariant || ((product.rawVariants && product.rawVariants.length > 0) ? product.rawVariants[0] : null)); }}
                                                    className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-8 px-14 text-xs rounded-pill flex-center gap-6 w-100"
                                                >
                                                    Add to Cart <i className="ph ph-shopping-cart" />
                                                </button>
                                            )}
                                        </div>

                                        {/* 3. Text details (Price & Name) */}
                                        <div className="product-card__content mt-4 flex-shrink-0 d-flex flex-column" style={{ flex: '1 1 auto' }}>
                                            <div className="product-card__price mb-4 d-flex align-items-center justify-content-start flex-wrap gap-6">
                                                <div className="d-flex align-items-center gap-6 flex-wrap">
                                                    <span className="text-heading text-sm fw-semibold">
                                                        {product.currentPrice} <span className="text-gray-500 fw-normal text-xs">{product.quantityText}</span>
                                                    </span>
                                                    {product.originalPrice && (
                                                        <span className="text-gray-400 text-xs fw-semibold text-decoration-line-through">
                                                            {product.originalPrice}
                                                        </span>
                                                    )}
                                                </div>
                                                {product.rawVariants && product.rawVariants.length > 1 && (
                                                    <span
                                                        className="badge rounded-4 fw-medium"
                                                        style={{
                                                            fontSize: '10px',
                                                            color: '#4b5563',
                                                            background: '#f3f4f6',
                                                            border: '1px solid #e5e7eb',
                                                            padding: '1px 5px',
                                                            whiteSpace: 'nowrap',
                                                            flexShrink: 0
                                                        }}
                                                        title={`${product.rawVariants.length} options available`}
                                                    >
                                                        +{product.rawVariants.length} options
                                                    </span>
                                                )}
                                            </div>

                                            <h6 className="title text-sm fw-semibold mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.4', height: '2.8em' }}>
                                                <Link to={`/product-details/${product.slug || product.id}`} className="link text-line-2">
                                                    {product.name}
                                                </Link>
                                            </h6>
                                        </div>
                            </div>
                        </div>
                    );
                    })}
                </div>
            </div>
        </div>
    )
}

export default ProductListOne
